import API from '../api/service.js';

export const services = {
    state: {
        services: [],
        servicesLoadStatus: 0,

        service: {},
        serviceLoadStatus: 0,

        serviceSlotDefinition: {},
        serviceSlotDefinitionLoadStatus: 0,

        serviceSlots: [],
        serviceSlotsLoadStatus: 0,

        serviceBlockSlotLoadStatus: 0,
        serviceBlockSlotUntil: 0,

        serviceUnblockSlotLoadStatus: 0,

        orderFormSentStatus: 0,
        orderInspectionFormSentStatus: 0,

        servicesView: 'map'
    },

    actions: {
        loadServices({ commit, rootState, dispatch }, data) {
            commit('setServices', []);
            commit('setServicesLoadStatus', 1);

            if (data.licensePlate.replace(/\s/g, '') == localStorage.getItem('license_plate').replace(/['"]+/g, '')) {
                API.getServices(data.distance, data.workroom, data.makeId, data.licensePlate.replace(/\s/g, ''), data.latitude, data.longitude)
                    .then(function( response) {
                        commit('setServices', response.data);

                        /*
                        dispatch('orderServices', {
                            order: rootState.filters.orderBy,
                            direction: rootState.filters.orderDirection
                        });
                        */

                        commit('setServicesLoadStatus', 2);
                    })
                    .catch(function() {
                        commit('setServices', []);
                        commit('setServicesLoadStatus', 3);
                    });
            }
        },

        loadService({ commit }, data) {
            commit('setServiceLoadStatus', 1);

            API.getService(data.slug, data.distance, data.workroom, data.makeId, data.licensePlate.replace(/\s/g, ''), data.latitude, data.longitude)
                .then(function(response) {
                    commit('setService', response.data);
                    commit('setServiceLoadStatus', 2);
                })
                .catch(function() {
                    commit('setService', {});
                    commit('setServiceLoadStatus', 3);
                });
        },

        loadServiceSlotDefinition({ commit }, data) {
            commit('setServiceSlotDefinitionLoadStatus', 1);

            API.getSlotDefinition(data.workroom_id)
                .then(function(response) {
                    commit('setServiceSlotDefinition', response.data);
                    commit('setServiceSlotDefinitionLoadStatus', 2);
                })
                .catch(function() {
                    commit('setServiceSlotDefinition', {});
                    commit('setServiceSlotDefinitionLoadStatus', 3);
                });
        },

        loadServiceSlots({ commit }, data) {
            commit('setServiceSlotsLoadStatus', 1);

            API.getSlots(data.workroom_id, data.workroom)
                .then(function(response) {
                    commit('setServiceSlots', response.data.data);
                    commit('setServiceSlotsLoadStatus', 2);
                })
                .catch(function() {
                    commit('setServiceSlots', []);
                    commit('setServiceSlotsLoadStatus', 3);
                });
        },

        blockServiceSlot({ commit }, data) {
            commit('setBlockServiceSlotLoadStatus', 1);

            API.blockSlot(data.slot_id, data.blocked_date)
                .then(function(response) {
                    commit('setBlockServiceSlotUntil', response.data.blocked_until_seconds);
                    commit('setBlockServiceSlotLoadStatus', 2);
                })
                .catch(function() {
                    commit('setBlockServiceSlotLoadStatus', 3);
                });
        },

        unblockServiceSlot({ commit }, data) {
            commit('setUnblockServiceSlotLoadStatus', 1);

            API.unblockSlot(data.slot_id)
                .then(function(response) {
                    commit('setUnblockServiceSlotLoadStatus', 2);
                })
                .catch(function() {
                    commit('setUnblockServiceSlotLoadStatus', 3);
                });
        },

        changeServicesView({ commit, state, dispatch }, view) {
            commit('setServicesView', view);
        },

        orderServices({ commit, state, dispatch }, data) {
            let localServices = state.services;

            switch(data.order) {
                case 'name':
                    localServices.sort(function(a, b) {
                        if (data.direction == 'desc') {
                            return ( ( a.name == b.name ) ? 0 : ( ( a.name < b.name ) ? 1 : -1 ) );
                        } else {
                            return ( ( a.name == b.name ) ? 0 : ( ( a.name > b.name ) ? 1 : -1 ) );
                        }
                    });
                    break;
                case 'distance':
                    localServices.sort(function(a, b) {
                        if (data.direction == 'desc') {
                            return ( ( a.distance == b.distance ) ? 0 : ( ( a.distance < b.distance ) ? 1 : -1 ) );
                        } else {
                            return ( ( a.distance == b.distance ) ? 0 : ( ( a.distance > b.distance ) ? 1 : -1 ) );
                        }
                    });
                    break;
            }

            commit('setServices', localServices);
        },

        orderToService({ commit }, data) {
            commit('setOrderFormSentStatus', 1);

            API.orderService(
                data.serviceWorkroomId,
                data.serviceName,
                data.selectedSlot,
                data.selectedEvent,
                data.slotTime,
                data.preferredLanguage,
                data.clientLocation,
                data.licensePlate,
                data.mileage,
                data.firstName,
                data.lastName,
                data.emailAddress,
                data.phoneNumber,
                data.phoneNumberPrefix,
                data.checkedDateType,
                data.preferredDate1,
                data.preferredDateTime1,
                data.preferredDate2,
                data.preferredDateTime2,
                data.preferredDate3,
                data.preferredDateTime3,
                data.preferredDatePeriod,
                data.preferredDatePeriodFrom,
                data.serviceOperations,
                data.serviceOperationsRepairText,
                data.serviceOperationsBreakdownText,
                data.serviceOperationsOtherText,
                data.extendedServicesOperations,
                data.extendedServicesOperationsReplacementCarAdditional,
                data.serviceSupplierLocation,
                data.pickupNote,
                data.pickupStreet,
                data.pickupTown,
                data.pickupZip,
                data.pickupGpsLat,
                data.pickupGpsLng,
                data.service,
                data.serviceSlotDefinition
            )
                .then(function(response) {
                    commit('setOrderFormSentStatus', 2);
                })
                .catch(function() {
                    commit('setOrderFormSentStatus', 3);
                });
        },

        orderInspection({ commit }, data) {
            commit('setOrderInspectionFormSentStatus', 1);

            API.orderInspection(
                data.serviceWorkroomId,
                data.serviceName,
                data.selectedSlot,
                data.selectedEvent,
                data.preferredLanguage,
                data.clientLocation,
                data.licensePlate,
                data.mileage,
                data.firstName,
                data.lastName,
                data.emailAddress,
                data.phoneNumber,
                data.phoneNumberPrefix,
                data.service,
                data.serviceSlotDefinition
            )
                .then(function(response) {
                    commit('setOrderInspectionFormSentStatus', 2);
                })
                .catch(function(error) {
                    if (error.response.status === 409) {
                        commit('setOrderInspectionFormSentStatus', 4);
                    } else {
                        commit('setOrderInspectionFormSentStatus', 3);
                    }
                });
        },
    },

    mutations: {
        setServices(state, services) {
            state.services = services;
        },

        setServicesLoadStatus(state, status) {
            state.servicesLoadStatus = status;
        },

        setService(state, service) {
            state.service = service;
        },

        setServiceLoadStatus(state, status) {
            state.serviceLoadStatus = status;
        },

        setServiceSlotDefinition(state, definition) {
            state.serviceSlotDefinition = definition;
        },

        setServiceSlotDefinitionLoadStatus(state, status) {
            state.serviceSlotDefinitionLoadStatus = status;
        },

        setServiceSlots(state, slots) {
            state.serviceSlots = slots;
        },

        setServiceSlotsLoadStatus(state, status) {
            state.serviceSlotsLoadStatus = status;
        },

        setBlockServiceSlotLoadStatus(state, status) {
            state.serviceBlockSlotLoadStatus = status;
        },

        setBlockServiceSlotUntil(state, status) {
            state.serviceBlockSlotUntil = status;
        },

        setUnblockServiceSlotLoadStatus(state, status) {
            state.serviceUnblockSlotLoadStatus = status;
        },

        setOrderFormSentStatus(state, status) {
            state.orderFormSentStatus = status;
        },

        setOrderInspectionFormSentStatus(state, status) {
            state.orderInspectionFormSentStatus = status;
        },

        setServicesView(state, view) {
            state.servicesView = view
        }
    },


    getters: {
        getServices(state) {
            return state.services;
        },

        getServicesLoadStatus(state) {
            return state.servicesLoadStatus;
        },

        getService(state) {
            return state.service;
        },

        getServiceLoadStatus(state) {
            return state.serviceLoadStatus;
        },

        getServiceSlotDefnition(state) {
            return state.serviceSlotDefinition;
        },

        getServiceSlotDefnitionLoadStatus(state) {
            return state.serviceSlotDefinitionLoadStatus;
        },

        getServiceSlots(state) {
            return state.serviceSlots;
        },

        getServiceSlotsLoadStatus(state) {
            return state.serviceSlotsLoadStatus;
        },

        getBlockServiceSlotLoadStatus(state) {
            return state.serviceBlockSlotLoadStatus;
        },

        getBlockServiceSlotUntil(state, status) {
            return state.serviceBlockSlotUntil;
        },

        getUnblockServiceSlotLoadStatus(state) {
            return state.serviceUnblockSlotLoadStatus;
        },

        getOrderFormSentStatus(state) {
            return state.orderFormSentStatus;
        },

        getOrderInspectionFormSentStatus(state) {
            return state.orderInspectionFormSentStatus;
        },

        getServicesView(state) {
            return state.servicesView;
        }
    }
}
